<template>
	<div id="app">
		<transition name="fade"  mode="out-in">
  		<router-view></router-view>
		</transition>
	</div>
</template>

<script> 
	export default {
	  name: 'app',
  	components: {}
  }
  
</script>
<!--
<link rel="stylesheet" type="text/css" href="http://fonts.googleapis.com/css?family=Ubuntu:regular,bold&subset=Latin" />
-->

<style lang="scss">
@font-face {
        font-family: Ubuntu;
        src: url(/static/font/Ubuntu-Regular.ttf);
}

body {
	margin: 0px;
	padding: 0px;
	font-family: Ubuntu,MS Sans Serif,Sans-serif,Arial;
	-webkit-font-smoothing: antialiased;
}

.toolbar {
	background: #f0f0f0;
	padding: 10px;
	margin: 10px 0px;
	.el-form-item {
		margin-bottom: 10px;
	}
}

.el-table .cell {line-height:15px !important}
.el-table td { padding: 3px 0 !important }
.el-table th {color:white;background-color:rgb(26, 126, 202) !important; padding:0 !important}
.el-button--small {padding: 8px 10px !important}
.el-submenu__title {line-height: 40px !important; font-weight:bold !important; height: 40px !important; background-color: #bbc2c7 !important}
.el-menu-item {line-height:40px !important; height: 40px !important}
.el-button {margin-left:3px !important}
	
/* wysiwyg aanpassingen */
.editr {max-width:99.6% !important;height:200px !important}
.editr--content {min-height:166px !important} 

.el-input.is-disabled .el-input__inner {color:#0d93ff !important}

.title {width:100% !important;max-width:300px !important}
</style>


// WEBPACK FOOTER //
// App.vue?85bf20dc